import{isTypedArray as y}from"../../predicate/isTypedArray.js";function i(r){return y(r)}export{i as isTypedArray};
